import React from "react";
import { Link } from "react-router-dom";
import ProductCard from "../components/ProductCard";
import { jewelleryProducts } from "../data/jewelleryData";
import { category } from "../data/jewelleryData";
import "./Home.scss";
import background from "../assets/background.jpg";

const Home = () => {
  // Get featured products (new items and best sellers)
  // const featuredProducts = jewelleryProducts
  //   .filter((product) => product.isNew === true || product.rating === 5)
  //   .slice(0, 6);
  const allProducts = [...jewelleryProducts, ...category];

  const featuredProducts = allProducts
    .filter((product) => product.isNew || product.rating === 5)
    .slice(0, 6);

  const handleAddToCart = (product) => {
    // Add to cart functionality would be implemented here
    console.log("Added to cart:", product.name);
    // You could integrate with a cart context or state management
  };

  return (
    <div className="home">
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-background">
          <img src={background} alt="Luxury Jewelry" className="hero-image" />
          <div className="hero-overlay"></div>
        </div>

        <div className="container">
          <div className="hero-content">
            <h1 className="hero-title fade-in-up">
              Discover Timeless <span className="highlight">Elegance</span>
            </h1>
            <p className="hero-subtitle fade-in-up">
              Exquisite artificial jewelry that captures the essence of luxury
              and sophistication. From stunning necklaces to elegant earrings,
              find your perfect piece.
            </p>
            <div className="hero-actions fade-in-up">
              {/* <Link to="/collections" className="btn btn-large">
                Shop Now
              </Link> */}
              <Link to="/about" className="btn btn-large">
                Our Story!
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features section">
        <div className="container">
          <div className="features-grid">
            <div className="feature-card">
              <div className="feature-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M20 6L9 17l-5-5" />
                </svg>
              </div>
              <h3>Premium Quality</h3>
              <p>
                Handcrafted with attention to detail using the finest materials
                and techniques.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z" />
                </svg>
              </div>
              <h3>Elegant Designs</h3>
              <p>
                Timeless designs that blend traditional craftsmanship with
                modern aesthetics.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M16 4h2a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V6a2 2 0 0 1 2-2h2" />
                  <rect x="8" y="2" width="8" height="4" rx="1" ry="1" />
                </svg>
              </div>
              <h3>Secure Shipping</h3>
              <p>
                Safe and secure delivery to your doorstep with insurance
                coverage.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg
                  width="48"
                  height="48"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                >
                  <path d="M21 11.5a8.38 8.38 0 0 1-.9 3.8 8.5 8.5 0 0 1-7.6 4.7 8.38 8.38 0 0 1-3.8-.9L3 21l1.9-5.7a8.38 8.38 0 0 1-.9-3.8 8.5 8.5 0 0 1 4.7-7.6 8.38 8.38 0 0 1 3.8-.9h.5a8.48 8.48 0 0 1 8 8v.5z" />
                </svg>
              </div>
              <h3>24/7 Support</h3>
              <p>
                Round-the-clock customer support to assist you with any queries.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Featured Products Section */}
      <section className="featured-products section section-light">
        <div className="container">
          <div className="section-header">
            <h2>Featured Products</h2>
            <p>Discover our most popular and newest jewelry pieces</p>
          </div>

          <div className="products-grid grid grid-2">
            {featuredProducts.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onAddToCart={handleAddToCart}
              />
            ))}
          </div>

          <div className="section-footer">
            <Link to="/collections" className="btn">
              View All Products
            </Link>
          </div>
        </div>
      </section>

      {/* Newsletter Section */}
      {/* <section className="newsletter section section-dark">
        <div className="container">
          <div className="newsletter-content">
            <h2>Stay Updated</h2>
            <p>Subscribe to our newsletter for the latest collections and exclusive offers</p>
            <form className="newsletter-form">
              <input 
                type="email" 
                placeholder="Enter your email address" 
                className="newsletter-input"
                required
              />
              <button type="submit" className="btn">
                Subscribe
              </button>
            </form>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default Home;
